import React from 'react';
import { Title, ButtonsGroup, Button, Checkbox } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import {
    privacyTermsSchema,
    privacyTermsToPartnersSchema,
} from 'validation-schemas/direto';
import AuthorizeInformationAccessDialog from './dialogs/authorize-information-access-dialog';
import UseTermsDialog from './dialogs/use-terms-dialog';
import PrivacyPolicyDialog from './dialogs/privacy-policy-dialog';
import Paragraph from 'components/commons/paragraph';
import EditInPlace from 'components/commons/edit-in-place';
import { getFirstName } from 'utils/utils';
import { IStepInfo } from 'providers/profile.config';
import whatsappIcon from 'assets/img/whatsapp-opt-in.png';

export type FinishScreenFields = {
    responsibleName: string;
    email: string;
    agreeTerms?: boolean;
    authorizeInformationAccess?: boolean;
    notifyViaWhatsapp?: boolean;
};

type PrivacyTermsLayoutProps = {
    initialValue: FinishScreenFields;
    loading?: boolean;
    stepInfo: IStepInfo;
    screenProfile: 'default' | 'partners';
    onSubmit(values: FinishScreenFields): void;
    onBack(): void;
};

const isPartnerProfile = (screenProfile: string) => (screenProfile === 'partners')

const PrivacyTermsLayout: React.FC<PrivacyTermsLayoutProps> = ({
    initialValue,
    loading = false,
    stepInfo: { title },
    screenProfile,
    onSubmit,
    onBack,
}: PrivacyTermsLayoutProps) => (
    <div className="normal-screen">
        <Form
            schema={
                screenProfile === 'default'
                    ? privacyTermsSchema
                    : privacyTermsToPartnersSchema
            }
            initialValues={initialValue}
            onSubmit={onSubmit}
            render={({ valid, values }) => (
                <>
                    <Title className="mb-4">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: title.replace(
                                    '%s',
                                    getFirstName(values.responsibleName)
                                ),
                            }}
                        />
                    </Title>

                    <Paragraph className="mb-4 ml-md-0">
                        {(isPartnerProfile(screenProfile)) ?
                            "Para analisar o pedido, precisamos que você aceite os termos." :
                            "Para analisar o seu pedido, precisamos que você confira seu email e aceite os termos."
                        }
                    </Paragraph>

                    {!isPartnerProfile(screenProfile) && <Field component={EditInPlace} type="email" name="email" />}


                    <Field
                        component={Checkbox}
                        name="notifyViaWhatsapp"
                        id="whatsapp_optin"
                        renderLabel={() => (
                            <div className="d-flex align-items-center">
                                aceito receber minha oferta de crédito por <img src={whatsappIcon} alt="Whatsapp" />
                            </div>
                        )}
                    />

                    <Field
                        component={Checkbox}
                        name="agreeTerms"
                        id="terms_of_use_optin"
                        renderLabel={() => (
                            <>
                                concordo com os <UseTermsDialog /> e <PrivacyPolicyDialog />
                            </>
                        )}

                    />

                    <Field
                        component={Checkbox}
                        name="authorizeInformationAccess"
                        id="data_access_optin"
                        renderLabel={() => (
                            <>
                                autorizo o <br className="d-block d-sm-none" />
                                <AuthorizeInformationAccessDialog />
                            </>
                        )}
                    />

                    {screenProfile === 'partners' && (
                        <Field
                            component={Checkbox}
                            name="partnerTerms"
                            renderLabel={() => (
                                <>
                                   afirmo que meu cliente está de acordo com essa solicitação e
                                   assumo responsabilidade por todos os dados preenchidos durante o processo.
                                </>
                            )}
                        />
                    )}

                    <ButtonsGroup>
                        <Button
                            label="voltar"
                            variant="secondary"
                            onClick={onBack}
                            data-category="Navegação Direto"
                            data-action="Clique Voltar"
                            data-label="Voltar /pedido/termos-de-uso"
                        />
                        <Button
                            loading={loading}
                            label="enviar"
                            disabled={!valid}
                            type="submit"
                        />
                    </ButtonsGroup>
                </>
            )}
        />
    </div>
);

export default PrivacyTermsLayout;
